import React, { createContext, useState, useContext } from 'react';

import HelpModal from '../components/HelpModal';
import HelpFab from '../components/HelpFab';

const HelpContext = createContext();

export const useHelp = () => useContext(HelpContext);

export function HelpProvider({ children }) {
  const [open, setOpen] = useState(false);
  const show  = () => setOpen(true);
  const hide  = () => setOpen(false);

  return (
    <HelpContext.Provider value={{ show }}>
      {children}
      {open && <HelpModal onClose={hide} />}
      <HelpFab onClick={show} />
    </HelpContext.Provider>
  );
}